import { useEffect, useState } from "react";
import { comments } from "../data/product";
import RatingStars from "./Rating";
import Modal from "./Modal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../utilis/api";
export const Details = ({ data }) => {
  console.log(data);
  return (
    <div className="px-1 py-4">
      <p
        className="text-[1.1rem] font-light font-Outfit"
        dangerouslySetInnerHTML={{ __html: data.description }}
      />
      <div className="flex flex-col gap-[1rem] mt-[1rem] text-[1.2rem] font-light">
        <h1 className="font-bold text-[1.3rem]">More Information</h1>

        <div className="grid grid-cols-[120px_1fr] gap-x-4">
          {data.product_type && (
            <>
              <span className="font-semibold">Type :</span>
              <span>{data.product_type}</span>
            </>
          )}
          {data.vendor && (
            <>
              <span className="font-semibold">Vendor :</span>
              <span>{data.vendor}</span>
            </>
          )}
          {data.tags && data.tags.length > 0 && (
            <>
              <span className="font-semibold">Tags :</span>
              <span>{data.tags.join(", ")}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const ShippingInfo = () => {
  return (
    <div className="text-gray-800 px-1 py-4 ">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">
        Shipping Information
      </h1>

      <div className="flex flex-col gap-4 text-sm sm:text-base leading-relaxed">
        <p>
          Any orders placed on the weekend will ship the following business day.
        </p>

        <p>
          <span className="font-semibold">FREE U.S. Shipping</span> on orders
          with product total of $59.95 or more (excluding shipping and other
          charges). Otherwise, shipping is $7.95.
        </p>

        <p>
          Orders shipped through Ground Shipping take{" "}
          <span className="font-semibold">5-7 business days</span> (Excluding
          Weekends and Holidays) to arrive. Orders are shipped via{" "}
          <span className="font-semibold">USPS, FedEx, and UPS</span>.
        </p>

        <div>
          <h2 className="font-semibold text-lg mb-2">
            Express Shipping Rates:
          </h2>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>
              2nd Day Delivery (Excluding Weekends and Holidays) &gt; $24.95
            </li>
            <li>
              Next Day Delivery (Excluding Weekends and Holidays) &gt; $39.95
            </li>
            <li>
              3 Days Delivery (Excluding Weekends and Holidays) &gt; $14.95
            </li>
          </ul>
          <p className="mt-1 text-sm sm:text-base">
            Please note we do not provide Express Shipping to APO, Hawaii, and
            Puerto Rico.
          </p>
        </div>

        <p>
          For Puerto Rico, Alaska, and Hawaii, delivery may take{" "}
          <span className="font-semibold">7 to 14 business days</span>.
        </p>

        <p>
          Orders are shipped through Ground Shipping and it takes{" "}
          <span className="font-semibold">5-7 business days</span> for final
          delivery. (Excluding Weekends and Holidays).
        </p>

        <p>
          Please note: There will be a{" "}
          <span className="font-semibold">one-day handling time</span> for all
          orders shipped via Ground Shipping.
        </p>

        <p>
          GiftExpress.com will ship all orders based on the customer's
          requirements but we cannot guarantee a carrier will deliver on a
          specified date since they are a third-party service.
        </p>
      </div>
    </div>
  );
};

const ReviewForm = ({ product, onClose }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const { user, token } = useSelector((state) => state.user);
  const [comment, setComment] = useState("");
  const handleSubmit = async () => {
    try {
      const payload = {
        comment,
        productItems: {
          productId: product.id,
          name: product.title,
          price: product?.variants?.[0].price,
          image: product.image,
        },
      };
      const response = await api.post("/coments/create", payload, {
        headers: { authorization: `Bearer ${token}` },
      });

      if (response.data?.meta?.success) {
        toast.success(response.data.meta.message, { autoClose: 3000 });
        onClose();
      } else {
        toast.error(response.data?.meta?.message || "Coment failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };
  return (
    <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
      {/* ⭐ Star Rating */}
      <div className="flex justify-center gap-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`text-3xl cursor-pointer transition duration-200 ${
              star <= (hover || rating)
                ? "text-yellow-400 scale-110"
                : "text-gray-700"
            }`}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          >
            ★
          </span>
        ))}
      </div>

      {/* 👤 Name Input */}
      <div>
        <label className="block text-gray-800 font-semibold mb-2">
          Your Name
        </label>
        <input
          type="text"
          placeholder="Enter your name"
          value={user?.name}
          disabled
          className="w-full p-3 rounded-lg border text-gray-800 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FFDD6A] transition"
        />
      </div>

      {/* 💬 Comment */}
      <div>
        <label className="block text-gray-800 font-semibold mb-2">
          Your Review
        </label>
        <textarea
          rows="4"
          placeholder="Write your review..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full p-3 rounded-lg text-gray-800 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FFDD6A] transition resize-none"
        />
      </div>

      {/* 🚀 Submit Button */}
      <button
        type="submit"
        className="bg-gray-500 text-white font-bold py-3 rounded-lg transition-all duration-300 hover:scale-105"
      >
        Submit Review
      </button>
    </form>
  );
};

export default ReviewForm;
export const Comments = ({ title, products }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, token } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  useEffect(() => {
    const getComments = async () => {
      try {
        const res = await api.get(`/coments/${products.id}`, {
          headers: { authorization: `Bearer ${token}` },
        });

        if (res.data.success && res.data.data.length > 0) {
          // Comments exist
          setData(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch comments:", error);
        setData([]); // fallback
      }
    };

    if (products?.id) getComments();
  }, [token, products]);
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="text-gray-800 p-4">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-[1.2rem] sm:text-[1.6rem]">
          Customer Reviews
        </h1>
        <button
          onClick={handleOpen}
          className="
  border border-gray-500 
  p-2 
  rounded-xl 
  font-light md:font-bold 
  text-gray-500 
  hover:text-white 
  hover:bg-gray-800 
  hover:border-white
  transition-all        
  duration-300          
  ease-in-out         
"
        >
          Add Reviews
        </button>
      </div>
      {data && data.length > 0 ? (
        <div className="mt-4 flex flex-col gap-[2rem]">
          {data.map((comment, index) => (
            <div key={index} className="flex flex-col gap-[0.5rem]">
              <RatingStars rating={5} />
              <h1 className="font-bold text-[1.4rem] capitalize">
                {comment?.user.name}
              </h1>
              <p className="text-[1.2rem]">{comment?.comment}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-4 flex text-white flex-col gap-[2rem]">
          <p className="text-[#666] text-[1.2rem]">
            This product has no comments yet.
          </p>
        </div>
      )}
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title={title}
        children={<ReviewForm product={products} onClose={handleClose} />}
      />
    </div>
  );
};
